import { Entry } from "contentful";
import { Store } from "../types/StoreLocator";
import { TypeNavigationFields } from "../types/contentful";
import { Inline, Block } from "@contentful/rich-text-types";

export const filterUniqueStores = (stores: Store[]): Store[] => {
	return stores.filter((store: Store) =>
		store.fid.toLowerCase().includes("cp")
	);
};

export const delay = (ms: number): Promise<string> => {
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve("");
		}, ms);
	});
};

export const isNavigation = (item: Entry<TypeNavigationFields>) => {
	return (
		item && item.fields && "title" in item.fields && "items" in item.fields
	);
};

export const legalDisclaimerRender = (node: Block | Inline) => {
	const url = node.data?.uri;
	const text =
		node.content && node.content.length > 0
			? (node.content[0] as any)?.value
			: "";

	return `<a target="_blank" href="${url}">${text}</a>`;
};

export const getEnvVariables = (isPreviewMode = false) => ({
	contentfulSpace: isPreviewMode
		? process.env.REACT_APP_PREVIEW_CONTENTFUL_SPACE
		: process.env.REACT_APP_CONTENTFUL_SPACE,
	contentfulEnv: isPreviewMode
		? process.env.REACT_APP_PREVIEW_CONTENTFUL_ENV
		: process.env.REACT_APP_CONTENTFUL_ENV,
	contentfulAccessToken: isPreviewMode
		? process.env.REACT_APP_PREVIEW_CONTENTFUL_ACCESS_TOKEN
		: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
	footerEntryId: isPreviewMode
		? process.env.REACT_APP_PREVIEW_FOOTER_ENTRY_ID
		: process.env.REACT_APP_FOOTER_ENTRY_ID,
	headerEntryId: isPreviewMode
		? process.env.REACT_APP_PREVIEW_HEADER_ENTRY_ID
		: process.env.REACT_APP_HEADER_ENTRY_ID,
	algoliaAppId: isPreviewMode
		? process.env.REACT_APP_PREVIEW_ALGOLIA_APP_ID
		: process.env.REACT_APP_ALGOLIA_APP_ID,
	algoliaSearchAPIKey: isPreviewMode
		? process.env.REACT_APP_PREVIEW_ALGOLIA_SEARCH_API_KEY
		: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
	algoliaIndexPrefix: isPreviewMode
		? process.env.REACT_APP_PREVIEW_ALGOLIA_INDEX_PREFIX
		: process.env.REACT_APP_ALGOLIA_INDEX_PREFIX,
	storeLocatorEntryId: isPreviewMode
		? process.env.REACT_APP_PREVIEW_STORE_LOCATOR_ENTRY_ID
		: process.env.REACT_APP_STORE_LOCATOR_ENTRY_ID
});

const redirectUrlByVendor: Record<string, string | undefined> = {
	sterling: process.env.REACT_APP_STERLING_REDIRECTION_URL,
	mediaclip: process.env.REACT_APP_PARTNER_REDIRECTION_URL,
	ricoh: process.env.REACT_APP_RICOH_REDIRECTION_URL
	// nebs: process.env.REACT_APP_NEBS_REDIRECTION_URL
};

export const getLinkHref = (
	targetUrl?: string,
	vendor?: string
): string | undefined => {
	if (!vendor || !targetUrl || !redirectUrlByVendor[vendor]) {
		return targetUrl;
	}
	const vendorRedirectUrl = redirectUrlByVendor[vendor];
	if (vendor === "nebs") {
		const searchParams = new URLSearchParams(window.location.search);
		const lang = searchParams.get("lng")?.toLowerCase();
		const vid = lang === "fr-ca" ? "20180912554" : "20180913555";
		return `${vendorRedirectUrl}StaplesIframeRedirect&vid=${vid}&returnUrl=${encodeURIComponent(
			targetUrl
		)}`;
	}
	return `${vendorRedirectUrl}StaplesIframeRedirect&returnUrl=${encodeURIComponent(
		targetUrl
	)}`;
};
